import React from 'react';
import clsx from 'clsx';
import styles from '../WarrantyRequestModal.module.scss';
import { Input } from '../../../../components/uikit/inputs/Input.tsx';
import { requiredRule } from '../../../../helpers/form/react-hook-form-helper.ts';
import { ActionText } from '../../../../components/uikit/ActionText.tsx';
import { Loading } from '../../../../components/uikit/suspense/Loading.tsx';
import { AdvancedFormReturnType } from '../../../../helpers/form/useAdvancedForm.ts';
import {
  Form,
  WarrantyRequestModalCategory,
} from '../WarrantyRequestModal.tsx';
import { UseQueryResult } from '@tanstack/react-query/build/modern';
import { ReplacementPartResponseDto } from '../../../../services/api/api-client.types.ts';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { useAnalytics } from 'helpers/analytics.ts';

type OwnProps = {
  form: AdvancedFormReturnType<Form>;
  replacementPart: UseQueryResult<ReplacementPartResponseDto, unknown>;
  turnOffArticleEditing: () => void;
  isDisabled: boolean;
};

export const ArticleEditing = (props: OwnProps) => {
  const { form, replacementPart, turnOffArticleEditing, isDisabled } = props;
  const i18n = useScopedTranslation('Page.WarrantyRequest');
  const { trackEvent } = useAnalytics();
  if (isDisabled) {
    return null;
  }
  async function searchArticleNumber() {
    trackEvent({
      category: WarrantyRequestModalCategory,
      action: 'Search article number',
      name: `Article number: ${form.getValues('article')}`,
    });
    const result = await form.trigger('article');
    if (result) {
      turnOffArticleEditing();
    }
  }

  return (
    <div
      className={clsx(
        styles.rowContainer,
        styles.columnGap10,
        styles.justifyContentSpaceBetween,
        styles.marginTop33,
      )}
    >
      <Input
        testId={'article-input'}
        {...form.register('article', requiredRule(i18n.t('required_error')))}
        errorText={
          form.formState.errors.article?.message
            ? form.formState.errors.article?.message
            : replacementPart.isError
            ? (replacementPart.error as any).response.detail
            : undefined
        }
        topRightHelperText={i18n.t('required')}
        topHelperText={i18n.t('article')}
        fullWidth={true}
        onChange={(e) => {
          form.setValue('article', e.target.value);
          form.clearErrors('article');
        }}
        onEnterPressed={async () => {
          await searchArticleNumber();
        }}
        maxLength={15}
      />
      <ActionText
        testId={'article-search'}
        className={
          !form.formState.errors.article?.message &&
          !replacementPart.isError &&
          styles.negativeMarginBottom
        }
        text={i18n.t('search')}
        onClickHandler={async () => {
          await searchArticleNumber();
        }}
      />
      <Loading
        loading={replacementPart.isLoading}
        wrapperClassName={styles.loader}
        className={styles.absoluteContainer}
      />
    </div>
  );
};
